import { useDataProvider, useRecordContext, useUpdate } from "ra-core";
import { Checkbox } from "@/components/ui/checkbox";

import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Contact } from "../types";
import { recordLeadEvent } from "./leadEvents";

export const ServicesChecklist = () => {
  const record = useRecordContext<Contact>();
  const { dealCategories } = useConfigurationContext();
  const dataProvider = useDataProvider();
  const [update, { isPending }] = useUpdate();
  if (!record) return null;

  const selected = new Set(record.services ?? []);

  const toggle = (value: string, label: string) => {
    const next = selected.has(value)
      ? [...selected].filter((item) => item !== value)
      : [...selected, value];
    update(
      "contacts",
      {
        id: record.id,
        data: { services: next },
        previousData: record,
      },
      {
        onSuccess: () => {
          void recordLeadEvent(dataProvider, {
            contact_id: record.id,
            sales_id: record.sales_id,
            type: "checklist_change",
            body: selected.has(value)
              ? `Unchecked ${label}`
              : `Checked ${label}`,
          });
        },
      },
    );
  };

  return (
    <ul className="flex flex-col gap-2">
      {dealCategories.map((service) => (
        <li key={service.value}>
          <label className="flex items-start gap-2 cursor-pointer">
            <Checkbox
              className="mt-0.5"
              checked={selected.has(service.value)}
              disabled={isPending}
              onCheckedChange={() => toggle(service.value, service.label)}
            />
            <span>{service.label}</span>
          </label>
        </li>
      ))}
    </ul>
  );
};
